import { last } from "lodash"

// Can be use directly as a helper function for a reselect selector
export const coalesce = (...values) => {
  for (const value of values) {
    if (value) {
      return value
    }
  }
  return last(values)
}
